import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const StyledForm = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;

    .error {
        position: relative;
        top: 4px;
        height: 5px;
        font-weight: 400;
        font-size: var(--font-size-xs);
        line-height: 14px;
        color: var(--color-error);
    }
`

export const EmailAlertsWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: ${({ theme: { colors } }) => `${colors.greys[500]}`};
`
